import React, { useEffect, useState } from "react";
import { Typography, Autocomplete, TextField, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import { API, graphqlOperation } from "aws-amplify";
import { listTransactionMaster } from "../../../graphql";
import LabelIcon from "./LabelIcon";
import ToolTipComponent from "./ToolTipComponent";
import SettingsIcon from "@mui/icons-material/Settings";
import NewVoucherSettingsModal from "../Modals/newVoucherSettingModal";

function TransVoucherComponent({
  data,
  setData,
  setInitialState,
  todayDate,
  paymentLabels,
  setTransGeneralSettingsFlag,
  transGeneralSettingsFlag,
  invoiceEntry,
  setTransVoucherArr,
  transVoucherArr,
  setPaymentTransID,
  setCurrentVoucherNo,
  currentVoucherNo,

  Type,
  companyData,
  paramsID,
  setOpenSettingsModal,
  openSettingsModal,
  setActiveTransVouchers,
  activeTransVouchers,
  transSerielNos,
}) {
  async function getTransVouchers() {
    try {
      let arr = [];
      const res = await API.graphql(graphqlOperation(listTransactionMaster));
      if (res?.data?.listTransactionMaster.length > 0) {
        res.data.listTransactionMaster.map((ele) => {
          if (Type === "Sales" || Type === "Pos" || Type === "DebitNote") {
            if (
              ele.transactiontypecd === "CashReceipt" ||
              ele.transactiontypecd === "BankReceipt"
            ) {
              arr.push(ele);
            }
          }
          if (Type === "Purchase" || Type === "CreditNote") {
            if (
              ele.transactiontypecd === "CashPayment" ||
              ele.transactiontypecd === "BankPayment"
            ) {
              arr.push(ele);
            }
          }
        });
        setTransVoucherArr(arr);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    // getTransVouchers();
  }, []);
  return (
    <>
      {transGeneralSettingsFlag !== -1 ? (
        <>
          <Grid
            item
            lg={4}
            xs={12}
            md={12}
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <Box sx={{ flex: 2 }}>
              <Autocomplete
                disablePortal
                disabled={
                  data?.partyName?.value == "" || invoiceEntry.length !== 0
                    ? true
                    : false
                }
                id={paymentLabels.seriesValue}
                options={transSerielNos}
                disableClearable
                value={data.transactionVoucher}
                isOptionEqualToValue={(option, value) =>
                  option?.value == value?.value
                }
                onChange={(e, newValue) => {
                  let voucherNo = "";
                  if (newValue.value !== "") {
                    activeTransVouchers.map((ele) => {
                      if (ele.SerialNumber === newValue.value) {
                        voucherNo =
                          ele.Prefix + ele.NextInvoiceNumber + ele.Suffix;
                      }
                    });
                    setData((prev) => ({
                      ...prev,
                      transactionSeries: newValue,
                      transactionVoucher: voucherNo,
                    }));
                  }
                }}
                sx={{
                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                    {
                      paddingBottom: "5px",
                    },
                  ".MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                    paddingTop: "6px",
                    paddingBottom: "5px",
                    paddingLeft: "6px",
                    paddingRight: "6px",
                  },
                }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    error={
                      data.errorStatus.seriesVouchers === true ? true : false
                    }
                    sx={{
                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "8.5px 7px",
                        },
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-14qz1ij-MuiListItemText-root": {
                        margin: "0px",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      // endAdornment: (
                      //   <LabelIcon value={data.transactionSeries.value} type="Accounts" params={params.InputProps.endAdornment} editMode={false}/>
                      // ),
                    }}
                    label={paymentLabels?.voucherName}
                    // label="Invoice Number"
                  />
                )}
              />
              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                }}
              >
                {data?.errorFields.transactionSeries}
              </Typography>
            </Box>
            {/* <Box sx={{ flex: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { sm: "flex-start" },
                  alignItems: "center",
                  padding: "8px",
                  borderRadius: "4px",
                  backgroundColor: "#a0a1a11a",
                  position: "relative",
                  height: "20px"
                }}
              >
                <Typography
                  sx={{
                    borderRadius: "4px",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    backgroundColor: "white",
                    position: "absolute",
                    top: "-6px",
                    left: "8px",
                    color: "#808080",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    fontWeight: "normal",
                  }}
                >
                  {paymentLabels.voucherName}
                </Typography>
                <Typography sx={{ color: "#808080" }}>
                  {data.transactionVoucher}
                </Typography>
              </Box>

              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                }}
              >
                {data?.errorFields.transactionVoucher}
              </Typography>
            </Box> */}
            <Box sx={{}}>
              <ToolTipComponent
                title={
                  Type === "Sales" || Type === "Pos"
                    ? "Receipt Number Settings"
                    : "Payment Number Settings"
                }
                placement="top"
                tooltipContent={
                  <IconButton
                    onClick={() => {
                      setOpenSettingsModal(true);
                    }}
                  >
                    <SettingsIcon sx={{ color: "#808080" }} />
                  </IconButton>
                }
              />
            </Box>
          </Grid>
        </>
      ) : (
        <>
          <Grid
            item
            lg={2}
            xs={12}
            md={12}
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <Box sx={{ flex: 2 }}>
              <TextField
                error={
                  data.errorStatus.transactionVoucher == true ? true : false
                }
                disabled={
                  data?.partyName?.value === "" || invoiceEntry?.length !== 0
                    ? true
                    : false
                }
                name={paymentLabels?.voucherValue}
                label={paymentLabels?.voucherName}
                size="small"
                type="text"
                fullWidth
                value={data?.transactionVoucher}
                required={true}
                onChange={(e) => {
                  const { name, value } = e.target;
                  if (value == "") {
                    setData((prev) => ({
                      ...prev,
                      transactionVoucher: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        transactionVoucher: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        transactionVoucher: "Voucher Number is requierd",
                      },
                    }));
                  } else {
                    let isValid = true;
                    transVoucherArr.map((ele) => {
                      if (ele.VoucherNumber !== currentVoucherNo) {
                        if (ele.VoucherNumber === value) {
                          isValid = false;
                        }
                      }
                    });
                    if (isValid == false) {
                      setData((prev) => ({
                        ...prev,
                        transactionVoucher: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          transactionVoucher: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          transactionVoucher: "Voucher Number already exists",
                        },
                      }));
                    } else {
                      setData((prev) => ({
                        ...prev,
                        transactionVoucher: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          transactionVoucher: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          transactionVoucher: "",
                        },
                      }));
                    }
                  }
                }}
                sx={{
                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                    {
                      paddingBottom: "5px",
                    },
                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                    {
                      paddingTop: "6px",
                      paddingBottom: "5px",
                      paddingLeft: "6px",
                    },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                    fontSize: "16px",
                    fontWeight: "bold",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <LabelIcon
                      value={data.transactionVoucher}
                      type="text"
                      editMode={false}
                    />
                  ),
                  inputProps: { maxLength: 16 },
                }}
              />
              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                }}
              >
                {data?.errorFields.transactionVoucher}
              </Typography>
            </Box>
            <Box sx={{}}>
              <ToolTipComponent
                title={
                  Type === "Sales" || Type === "Pos"
                    ? "Receipt Number Settings"
                    : "Payment Number Settings"
                }
                placement="top"
                tooltipContent={
                  <IconButton
                    onClick={() => {
                      setOpenSettingsModal(true);
                    }}
                  >
                    <SettingsIcon sx={{ color: "#808080" }} />
                  </IconButton>
                }
              />
            </Box>
          </Grid>
        </>
      )}
      {/* {openSettingsModal === true && ( */}
      <NewVoucherSettingsModal
        open={openSettingsModal}
        label={paymentLabels.voucherType}
        type={paymentLabels.voucherType} //paymentlabels
        setOpen={setOpenSettingsModal}
      />
      {/* )} */}
    </>
  );
}

export default TransVoucherComponent;
